import React from "react";
import { useSearchParams } from "react-router-dom";
import "./PaymentStatus.css"; // for styles

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();

  const paymentId = searchParams.get("razorpay_payment_id");
  const linkId = searchParams.get("razorpay_payment_link_id");
  const status = searchParams.get("razorpay_payment_link_status");
  const signature = searchParams.get("razorpay_signature");

  const date = new Date().toLocaleString();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
    <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center space-y-6">
      
      {/* App Logo */}
      <div className="flex justify-center">
        <img src="/header_logo.svg" alt="App Logo" className="h-14 mb-4" />
      </div>
  
      {/* Payment Status */}
      <h2 className="text-2xl font-bold text-green-600 flex items-center justify-center space-x-2">
        <span>✅</span>
        <span>Payment Successful</span>
      </h2>
      <p className="text-gray-600">Thank you! Your payment was successful.</p>
  
      <div className="border-t border-gray-200 my-4"></div>
  
      {/* Payment Details */}
      <div className="text-left space-y-2 text-gray-700 text-sm">
        <p><span className="font-semibold">Payment ID:</span> {paymentId}</p>
        <p><span className="font-semibold">Payment Link ID:</span> {linkId}</p>
        <p><span className="font-semibold">Status:</span> {status}</p>
        <p><span className="font-semibold">Date:</span> {date}</p>
      </div>
  
      <div className="border-t border-gray-200 my-4"></div>
  
      {/* Screenshot Note */}
      <p className="text-blue-500 text-sm">📸 Take a screenshot of this page for your records.</p>
    </div>
  </div>
  
  );
};

export default PaymentStatus;
